// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DYQ9","content":"styles_content__2OhMg","row":"styles_row__3C63d","footer":"styles_footer__uJ74F","phraseLength":"styles_phraseLength__1AmeX"};